import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useEmployeeDetail(id) {
  return useSWR(
    !!id
      ? {
          path: `/api/v1/users/${id}`,
          method: "GET",
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useEmployeeDetail;
